import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { checkValid, setValueForm, updateValidate } from '../../../../../../../helpers/form/FormHelper'
import { responseError } from '../../../../../../../helpers/response/ResponseHelper'
import ErrorMessage from '../../../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../../../UI/form/MyButton'
import PaymentTypeSelect from './fields/PaymentTypeSelect'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../../../helpers/form/FormData'
import { addSupplyBillPaymentAPI, editSupplyBillPaymentAPI } from '../../../../../../../api/supply/supplyBillPaymentAPI'
import PaymentBillNumberField from './fields/PaymentBillNumberField'
import { useDispatch } from 'react-redux'
import { addSupplyBillPayment, setSupplyBillPayment } from '../../../../../../../store/supplyBillSlice'

const SupplyBillPaymentForm = ({ supplyBillId, billPaymentBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(billPaymentBd ? billPaymentBd : {}) // Дані з форми
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()
        const dataForBd = setDataForBd()

        setError('')
        setLoading(true)

        if (dataForBd.id) {
            edit(dataForBd)
        } else {
            add(dataForBd)
        }

        // editSupplyOrderUserAPI({
        //     supplyOrderId, userId: data.userId
        // }).then(data => {
        //     setOpen(false)
        //     setLoading(false)
        // }).catch(e => {
        //     setError(responseError(e))
        //     setLoading(false)
        // })
    }

    const add = (dataForBd) => {
        addSupplyBillPaymentAPI(dataForBd).then(data => {
            if (data) {
                dispatch(addSupplyBillPayment(data))
            }
            // if (data && data.supplyBills) {
            //     dispatch(setSupplyOrderBills(data.supplyBills))
            // }
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const edit = (dataForBd) => {
        editSupplyBillPaymentAPI(dataForBd).then(data => {
            if (data) {
                dispatch(setSupplyBillPayment(data))
            }
            // if (data && data.supplyOrderNew.items) {
            //     dispatch(editSupplyOrderItems(data.supplyOrderNew.items))
            // }
            // if (data && data.supplyBills) {
            //     dispatch(setSupplyOrderBills(data.supplyBills))
            // }
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const setDataForBd = () => {
        let dataForBd = {
            supplyBillId,
            type: data.type,
            billNumber: data.billNumber,
        }

        if (data.id) {
            dataForBd = {
                ...dataForBd,
                id: data.id
            }
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
        {
			formDataProductIsField('type', 'supplyBillPayment') ?
				<PaymentTypeSelect
					required={formDataProductRequiredField('type', 'supplyBillPayment')}
					setValidate={e => updateValidate(setValid, 'type', e)}
					setValueForm={e => setValueForm(setData, 'type', e)}
					forciblyValue={data && data.type ? data.type : ''}
				/>
			: ''
        }
        {
			formDataProductIsField('billNumber', 'supplyBillPayment') ?
				<PaymentBillNumberField
					required={formDataProductRequiredField('billNumber', 'supplyBillPayment')}
					setValidate={e => updateValidate(setValid, 'billNumber', e)}
					setValueForm={e => setValueForm(setData, 'billNumber', e)}
					forciblyValue={data && data.billNumber ? data.billNumber : ''}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default SupplyBillPaymentForm